import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...(token && { Authorization: `Bearer ${token}` }),
});

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getCategoryIcon = (category) => {
  const icons = {
    audio: 'Speaker',
    catering: 'UtensilsCrossed',
    furniture: 'Sofa',
    lighting: 'Lightbulb',
    tent: 'Tent',
    other: 'Package',
  };
  return icons[category] || icons.other;
};

export const getCategoryColor = (category) => {
  const colors = {
    audio: 'bg-purple-500/10 text-purple-500 border-purple-500/20',
    catering: 'bg-orange-500/10 text-orange-500 border-orange-500/20',
    furniture: 'bg-amber-500/10 text-amber-500 border-amber-500/20',
    lighting: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
    tent: 'bg-green-500/10 text-green-500 border-green-500/20',
    other: 'bg-gray-500/10 text-gray-500 border-gray-500/20',
  };
  return colors[category] || colors.other;
};

export const getStatusColor = (status) => {
  const colors = {
    draft: 'bg-gray-500/10 text-gray-500 border-gray-500/20',
    sent: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    accepted: 'bg-green-500/10 text-green-500 border-green-500/20',
    signed: 'bg-purple-500/10 text-purple-500 border-purple-500/20',
    rejected: 'bg-red-500/10 text-red-500 border-red-500/20',
    invoiced: 'bg-indigo-500/10 text-indigo-500 border-indigo-500/20',
    finalized: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    paid: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20',
    planned: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    confirmed: 'bg-green-500/10 text-green-500 border-green-500/20',
    in_progress: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
    completed: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/20',
    cancelled: 'bg-red-500/10 text-red-500 border-red-500/20',
  };
  return colors[status] || colors.draft;
};

export const CATEGORIES = [
  { value: 'audio', label: 'Audio / Son' },
  { value: 'catering', label: 'Traiteur' },
  { value: 'furniture', label: 'Mobilier' },
  { value: 'lighting', label: 'Éclairage' },
  { value: 'tent', label: 'Tentes / Structures' },
  { value: 'other', label: 'Autre' },
];

export const QUOTE_STATUSES = [
  { value: 'draft', label: 'Brouillon' },
  { value: 'sent', label: 'Envoyé' },
  { value: 'accepted', label: 'Accepté' },
  { value: 'signed', label: 'Signé' },
  { value: 'rejected', label: 'Refusé' },
  { value: 'invoiced', label: 'Facturé' },
];

export const EVENT_STATUSES = [
  { value: 'planned', label: 'Planifié' },
  { value: 'confirmed', label: 'Confirmé' },
  { value: 'in_progress', label: 'En cours' },
  { value: 'completed', label: 'Terminé' },
  { value: 'cancelled', label: 'Annulé' },
];

export const INVOICE_STATUSES = [
  { value: 'draft', label: 'Brouillon' },
  { value: 'finalized', label: 'Finalisée' },
  { value: 'paid', label: 'Payée' },
];

export const PAYMENT_METHODS = [
  { value: 'transfer', label: 'Virement' },
  { value: 'check', label: 'Chèque' },
  { value: 'cash', label: 'Espèces' },
  { value: 'card', label: 'Carte bancaire' },
];
